export function lowerHexagonsDate(key) {
  const constItens = {
    color: '#eee',
    isVisible: true,
    filter_blur: '1.5px',
    initial_scale: 1,
    gain_scale: 1.2,
    duration_go: 10000,
    duration_back: 10000,
    interval_timer: 10000,
    timeAnimation: '10s',
    interationCount: 'infinite',
    animation_enable: false,
    looping: true,
  };
  const hexagons = [
    {
      icon: 'wquarks',
      key: 5,
      width_hexagon: '30%',
      rotation_from: '30deg',
      rotation_to: '30deg',
      traslate_to: 'translate(-10%, 15%)',
      traslate_from: 'translate(-10%, 15%)',
      opacity_from: 0.4,
      opacity_to: 0.4,
      delay_timer: 0,
      ...constItens,
    },
    {
      icon: 'app',
      key: 4,
      width_hexagon: '15%',
      rotation_from: '0deg',
      rotation_to: '0deg',
      traslate_to: 'translate(-190%, -120%)',
      traslate_from: 'translate(-190%, -120%)',
      opacity_from: 0.5,
      opacity_to: 0.5,
      delay_timer: 1,
      ...constItens,
    },
    {
      icon: 'reports',
      key: 3,
      width_hexagon: '10%',
      rotation_from: '0deg',
      traslate_to: 'translate(-278%, -85%)',
      traslate_from: 'translate(-278%, -85%)',
      opacity_from: 0.55,
      opacity_to: 0.55,
      delay_timer: 1.25,
      ...constItens,
    },
    {
      icon: 'softwares',
      key: 2,
      width_hexagon: '16%',
      rotation_from: '30deg',
      rotation_to: '30deg',
      traslate_to: 'translate(-170%, 40%)',
      traslate_from: 'translate(-170%, 40%)',
      opacity_from: 0.6,
      opacity_to: 0.6,
      delay_timer: 1,
      ...constItens,
    },
    {
      icon: 'finance',
      key: 1,
      width_hexagon: '10%',
      rotation_from: '30deg',
      rotation_to: '30deg',
      traslate_to: 'translate(-252%, 78%)',
      traslate_from: 'translate(-252%, 78%)',
      opacity_from: 0.65,
      opacity_to: 0.65,
      delay_timer: 1.25,
      ...constItens,
    },
    {
      icon: 'websites',
      key: 0,
      width_hexagon: '10%',
      rotation_from: '30deg',
      rotation_to: '30deg',
      traslate_to: 'translate(-415%, -30%)',
      traslate_from: 'translate(-415%, -30%)',
      opacity_from: 0.7,
      opacity_to: 0.7,
      delay_timer: 2,
      ...constItens,
    },
  ];
  if (key === 'ALL') return hexagons;
  return hexagons[key];
}

export default lowerHexagonsDate;



// WEBPACK FOOTER //
// ./src/components/UI/Animations/AnimationDate/lowerHexagonsDate.jsx